(() => {
  const root = document.getElementById('SensoryAromatherapy');
  if (!root) return;

  const $ = (selector, context = root) => context.querySelector(selector);
  const $$ = (selector, context = root) => [...context.querySelectorAll(selector)];

  const products = JSON.parse($('[data-sar-products]')?.textContent || '{}');
  const config = JSON.parse($('[data-sar-config]')?.textContent || '{}');
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

  const bundles = {
    hoodie: {
      note: '1 hoodie, 2 scent discs, shipping calculated at checkout',
      cta: 'Claim Hoodie Offer',
      fallbackPrice: '$89.99',
      // Display discount mirrors the published Kaching bar ($89.99 from $94.99).
      displayMultiplier: 89.99 / 94.99,
      items: [{ id: 'hoodie-1', label: 'Hoodie', type: 'hoodie', needsScent: true }]
    },
    set: {
      note: 'Hoodie + sweatpants + free shipping',
      cta: 'Claim Complete Set',
      fallbackPrice: '$139.99',
      // Display discount mirrors the published Kaching bar ($139.99 from $154.98).
      displayMultiplier: 139.99 / 154.98,
      items: [
        { id: 'hoodie-1', label: 'Hoodie', type: 'hoodie', needsScent: true },
        { id: 'pants', label: 'Sweatpants', type: 'pants', needsScent: false }
      ]
    },
    two: {
      note: '2 hoodies, 4 scent discs, free shipping, upgraded gifts',
      cta: 'Claim 2-Hoodie Offer',
      fallbackPrice: '$159.99',
      // Display discount mirrors the published Kaching bar ($159.99 from $189.98).
      displayMultiplier: 159.99 / 189.98,
      items: [
        { id: 'hoodie-1', label: 'Hoodie 1', type: 'hoodie', needsScent: true },
        { id: 'hoodie-2', label: 'Hoodie 2', type: 'hoodie', needsScent: true }
      ]
    }
  };

  const fallbackGifts = [
    { name: 'Anxiety Workbook', value: '$12 value', image: 'https://cdn.shopify.com/s/files/1/0714/5868/5233/files/1_f8cba3a5-f997-46fa-b438-3469ba06d7aa_200x200.jpg?v=1754903399' },
    { name: 'Journal eBook', value: '$12 value', image: 'https://cdn.shopify.com/s/files/1/0714/5868/5233/files/2_7e8839ed-11f0-4bde-ab51-bc4848862384_200x200.jpg?v=1755147028' },
    { name: 'Stickers', value: '$6 value', image: 'https://cdn.shopify.com/s/files/1/0714/5868/5233/files/StickerPack_5d188d69-adb9-499b-a93a-7ba5ccab7117_200x200.jpg?v=1760689941' },
    { name: 'Cloud Tote Bag', value: '$24 value', image: 'https://cdn.shopify.com/s/files/1/0714/5868/5233/files/custom_tote_bags_200x200.png?v=1762198527' },
    { name: 'Golden Ticket', value: '$12 value', image: 'https://cdn.shopify.com/s/files/1/0714/5868/5233/files/Screenshot2025-10-16at11.19.11PM_200x200.jpg?v=1760688302' }
  ];

  const state = { bundle: 'set', selected: {}, editingId: null };
  const els = {
    tabs: $('.sar-tabs'),
    items: $('[data-sar-items]'),
    gifts: $('[data-sar-gifts]'),
    total: $('[data-sar-total]'),
    original: $('[data-sar-original]'),
    savings: $('[data-sar-savings]'),
    note: $('[data-sar-note]'),
    shippingBadge: $('[data-sar-shipping-badge]'),
    shippingStatus: $('[data-sar-shipping-status]'),
    shippingCopy: $('[data-sar-shipping-copy]'),
    atc: $('[data-sar-atc]'),
    sticky: $('[data-sar-sticky]'),
    stickyMeta: $('[data-sar-sticky-meta]'),
    stickyPrice: $('[data-sar-sticky-price]'),
    stickyScroll: $('[data-sar-sticky-scroll]'),
    modal: $('[data-sar-modal]'),
    modalTitle: $('[data-sar-modal-title]'),
    modalGroups: $('[data-sar-modal-groups]'),
    modalSave: $('[data-sar-modal-save]'),
    sizeGuide: $('[data-sar-size-guide]')
  };

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, moneyFormat);
    const amount = (Number(cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
  }

  function productFor(type) {
    return products[type] || {};
  }

  function optionValues(product, index) {
    return [...new Set((product.variants || []).map((variant) => variant.options?.[index]).filter(Boolean))];
  }

  function firstVariant(type) {
    const product = productFor(type);
    return (product.variants || []).find((variant) => variant.available) || (product.variants || [])[0] || null;
  }

  function optionIndex(type, key) {
    const product = productFor(type);
    const optionNames = product.options || [];
    const aliases = {
      scent: ['scent', 'fragrance', 'aroma'],
      size: ['size'],
      color: ['color', 'colour']
    }[key] || [key];

    const detectedIndex = optionNames.findIndex((name) => aliases.includes(String(name || '').trim().toLowerCase()));
    if (detectedIndex !== -1) return detectedIndex;

    // Fallbacks preserve the current product setup if Shopify option names are missing from the payload.
    if (type === 'hoodie') return { scent: 0, size: 1, color: 2 }[key];
    return { size: 0, color: 1 }[key];
  }

  function optionValuesFor(type, key) {
    const index = optionIndex(type, key);
    if (index === undefined) return [];
    return optionValues(productFor(type), index);
  }

  function findVariant(type, selectionOrColor, maybeSize) {
    const product = productFor(type);
    const target = typeof selectionOrColor === 'object'
      ? selectionOrColor
      : { color: selectionOrColor, size: maybeSize };

    return (product.variants || []).find((variant) => {
      const scentOk = type !== 'hoodie' || !target.scent || variant.options?.[optionIndex(type, 'scent')] === target.scent;
      const colorOk = !target.color || variant.options?.[optionIndex(type, 'color')] === target.color;
      const sizeOk = !target.size || variant.options?.[optionIndex(type, 'size')] === target.size;
      return scentOk && colorOk && sizeOk && variant.available;
    }) || (product.variants || []).find((variant) => {
      const scentOk = type !== 'hoodie' || !target.scent || variant.options?.[optionIndex(type, 'scent')] === target.scent;
      const colorOk = !target.color || variant.options?.[optionIndex(type, 'color')] === target.color;
      const sizeOk = !target.size || variant.options?.[optionIndex(type, 'size')] === target.size;
      return scentOk && colorOk && sizeOk;
    }) || firstVariant(type);
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function normalizeSrc(src) {
    return src?.startsWith('//') ? `https:${src}` : (src || '');
  }

  function imageUrl(selection) {
    const variantImage = normalizeSrc(selection.variant?.featured_image?.src || selection.variant?.featured_media?.preview_image?.src);
    if (variantImage) return variantImage;

    const product = productFor(selection.type);
    const colorKey = normalizeText(selection.color);
    const colorMatch = (product.images || []).find((src) => normalizeText(src).includes(colorKey));
    if (colorMatch) return normalizeSrc(colorMatch);

    return normalizeSrc(product.featured_image || '');
  }

  function defaultSelection(item) {
    const variant = firstVariant(item.type);
    const scent = item.needsScent ? (variant?.options?.[optionIndex(item.type, 'scent')] || optionValuesFor(item.type, 'scent')[0] || 'Lavender') : '';
    const color = variant?.options?.[optionIndex(item.type, 'color')] || optionValuesFor(item.type, 'color')[0] || 'Baby blue';
    const size = variant?.options?.[optionIndex(item.type, 'size')] || optionValuesFor(item.type, 'size')[0] || 'XS';
    const selection = { ...item, color, size, scent };
    selection.variant = findVariant(item.type, selection);
    return selection;
  }

  function currentBundle() {
    return bundles[state.bundle];
  }

  function resetSelections(bundleKey) {
    state.bundle = bundleKey;
    state.selected = {};
    currentBundle().items.forEach((item) => {
      state.selected[item.id] = defaultSelection(item);
    });
    render();
  }

  function subtotal() {
    return Object.values(state.selected).reduce((sum, selection) => sum + (selection.variant?.price || 0), 0);
  }

  function offerPrice(cents, bundleKey = state.bundle) {
    const multiplier = bundles[bundleKey]?.displayMultiplier || 1;
    return cents ? Math.round(cents * multiplier) : 0;
  }

  function giftsForBundle() {
    const configured = config.kaching?.gifts?.[state.bundle] || [];
    if (configured.length) return configured;
    const count = state.bundle === 'two' ? 5 : 3;
    return fallbackGifts.slice(0, count);
  }

  function allDisplayGifts() {
    const configured = [...(config.kaching?.gifts?.hoodie || []), ...(config.kaching?.gifts?.set || []), ...(config.kaching?.gifts?.two || [])];
    const source = configured.length ? configured : fallbackGifts;
    const byName = new Map();
    source.forEach((gift) => {
      if (!byName.has(gift.name)) byName.set(gift.name, gift);
    });
    return [...byName.values()];
  }

  function renderTabs() {
    $$('.sar-tab').forEach((tab) => {
      const active = tab.dataset.bundle === state.bundle;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');

      const bundle = bundles[tab.dataset.bundle];
      const total = bundle.items.reduce((sum, item) => sum + (firstVariant(item.type)?.price || 0), 0);
      const discounted = offerPrice(total, tab.dataset.bundle);
      const savings = total - discounted;
      const price = tab.querySelector('[data-tab-price]');
      const savingsEl = tab.querySelector('[data-tab-savings]');
      if (price) price.textContent = discounted ? formatMoney(discounted) : bundle.fallbackPrice;
      if (savingsEl) savingsEl.textContent = savings > 0 ? `Save ${formatMoney(savings)}` : '';
    });
  }

  function renderGifts() {
    const unlockedNames = new Set(giftsForBundle().map((gift) => gift.name));
    els.gifts.innerHTML = `
      <div class="sar-builder__title">Free sensory gifts included</div>
      <div class="sar-gift-items">
        ${allDisplayGifts().map((gift) => {
          const unlocked = unlockedNames.has(gift.name);
          return `<span class="sar-gift ${unlocked ? 'is-unlocked' : 'is-locked'}">
            <span class="sar-gift__status">${unlocked ? '✓' : '🔒'}</span>
            <span class="sar-gift__thumb"><img src="${gift.image}" alt=""></span>
            <strong>${gift.name}</strong>
            ${gift.value ? `<small>${gift.value}</small>` : ''}
          </span>`;
        }).join('')}
      </div>`;
  }

  function renderItems() {
    els.items.innerHTML = Object.values(state.selected).map((selection) => {
      const image = imageUrl(selection);
      const scent = selection.needsScent ? `${selection.scent} · ` : '';
      return `<div class="sar-item-card" data-item-id="${selection.id}">
        <button class="sar-size-guide-trigger sar-item-card__size-guide" type="button" data-sar-size-guide-open data-guide-type="${selection.type}">${selection.label} size guide</button>
        <button type="button" class="sar-item" data-item-edit="${selection.id}">
          ${image ? `<img src="${image}" alt="">` : '<span></span>'}
          <span><strong>${selection.label}</strong><span>${scent}${selection.color} / ${selection.size}</span></span>
          <span class="sar-edit-label">Edit</span>
        </button>
        <div class="sar-inline-controls">
          ${selection.needsScent ? selectControl(selection, 'scent', 'Scent') : ''}
          ${selectControl(selection, 'color', 'Color')}
          ${selectControl(selection, 'size', 'Size')}
        </div>
      </div>`;
    }).join('');
  }

  function selectControl(selection, key, label) {
    return `<label><span>${label}</span><select class="sar-select" data-control="${key}" data-item-id="${selection.id}">
      ${optionValuesFor(selection.type, key).map((value) => `<option value="${value}"${value === selection[key] ? ' selected' : ''}>${value}</option>`).join('')}
    </select></label>`;
  }

  function syncGalleryToColor(color) {
    const slider = $('.sar-product-slider');
    if (!slider || !color || !Array.isArray(slider.selectedOptions)) return;
    const colorIndex = Number(slider.dataset.colorOptionIndex || 0);
    slider.selectedOptions[colorIndex] = color;
    if (typeof slider.refreshState === 'function') {
      slider.refreshState({ changedIndex: colorIndex, preserveIndex: false });
    }
  }

  function updateSelection(itemId, key, value) {
    const selection = state.selected[itemId];
    if (!selection) return;
    selection[key] = value;
    selection.variant = findVariant(selection.type, selection);
    if (selection.type === 'hoodie' && key === 'color') syncGalleryToColor(value);
    render();
  }

  function renderTotal() {
    const total = subtotal();
    const discountedTotal = offerPrice(total);
    const savings = total - discountedTotal;
    els.total.textContent = discountedTotal ? formatMoney(discountedTotal) : currentBundle().fallbackPrice;
    els.original.textContent = total ? formatMoney(total) : '';
    els.savings.textContent = savings > 0 ? `You save ${formatMoney(savings)} when you claim this bundle today.` : 'Bundle savings applied today.';
    els.note.textContent = currentBundle().note;
    const freeShippingUnlocked = state.bundle !== 'hoodie';
    els.shippingBadge?.classList.toggle('is-locked', !freeShippingUnlocked);
    if (els.shippingStatus) els.shippingStatus.textContent = freeShippingUnlocked ? 'Free shipping unlocked' : 'Free shipping locked';
    if (els.shippingCopy) els.shippingCopy.textContent = freeShippingUnlocked ? 'on this offer today' : 'choose Set or 2 Hoodie to unlock';
    els.atc.textContent = currentBundle().cta;
    els.stickyMeta.textContent = currentBundle().note;
    els.stickyPrice.textContent = discountedTotal ? formatMoney(discountedTotal) : currentBundle().fallbackPrice;
  }

  function render() {
    renderTabs();
    renderGifts();
    renderItems();
    renderTotal();
  }

  function choiceGroup(label, key, values, activeValue) {
    return `<div><div class="sar-builder__title">${label}</div><div class="sar-choice-row" data-choice-key="${key}">
      ${values.map((value) => `<button type="button" class="sar-choice${value === activeValue ? ' is-active' : ''}" data-choice-value="${value}">${value}</button>`).join('')}
    </div></div>`;
  }

  function openModal(itemId) {
    const selection = state.selected[itemId];
    if (!selection) return;
    state.editingId = itemId;
    const product = productFor(selection.type);
    els.modalTitle.textContent = `Customize ${selection.label}`;
    els.modalGroups.innerHTML = `${selection.needsScent ? choiceGroup('Scent', 'scent', config.scentOptions || ['Lavender', 'Rose', 'Jasmine'], selection.scent) : ''}
      ${choiceGroup('Color', 'color', optionValuesFor(selection.type, 'color'), selection.color)}
      <div class="sar-size-head"><div class="sar-builder__title">Size</div><button class="sar-size-guide-trigger" type="button" data-sar-size-guide-open data-guide-type="${selection.type}">Size guide</button></div>
      ${choiceGroup('', 'size', optionValuesFor(selection.type, 'size'), selection.size)}`;
    els.modal.hidden = false;
  }

  function closeModal(save = false) {
    if (save && state.editingId) {
      const selection = state.selected[state.editingId];
      $$('[data-choice-key]', els.modalGroups).forEach((group) => {
        const key = group.dataset.choiceKey;
        const value = group.querySelector('.is-active')?.dataset.choiceValue;
        if (value) selection[key] = value;
      });
      selection.variant = findVariant(selection.type, selection);
      render();
    }
    els.modal.hidden = true;
    state.editingId = null;
  }

  function kachingBridge() {
    return $('[data-sar-kaching-bridge]');
  }

  function selectKachingBar() {
    const bridge = kachingBridge();
    const bar = config.kaching?.bars?.[state.bundle];
    if (!bridge || !bar) return false;

    const radio = [...bridge.querySelectorAll('input[type="radio"]')].find((input) => input.value === bar);
    if (radio) {
      radio.click();
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    const titleByBundle = {
      hoodie: 'Hoodie',
      set: 'Hoodie + Sweatpants Set',
      two: '2 Hoodie Set'
    };
    const targetTitle = titleByBundle[state.bundle];
    const bars = [...bridge.querySelectorAll('.kaching-bundles__bar, label, button')];
    const target = bars.find((barEl) => (barEl.textContent || '').includes(targetTitle));
    if (!target) return false;
    target.click();
    return true;
  }

  function checkoutUrl() {
    const freeShippingBundles = config.kaching?.freeShippingBundles || [];
    const freeShippingCode = config.kaching?.freeShippingDiscountCode;
    if (freeShippingCode && freeShippingBundles.includes(state.bundle)) {
      return `/discount/${encodeURIComponent(freeShippingCode)}?redirect=/checkout`;
    }
    return '/checkout';
  }

  async function addToCart() {
    const bridge = kachingBridge();
    const block = bridge?.querySelector('kaching-bundles-block');

    if (!bridge || !block || typeof block.items !== 'function') {
      els.atc.textContent = 'Bundle unavailable';
      return;
    }

    els.atc.disabled = true;
    els.atc.textContent = 'Adding...';
    try {
      selectKachingBar();
      await new Promise((resolve) => setTimeout(resolve, 350));

      const items = block.items();
      if (!items?.length) throw new Error('Kaching bundle items unavailable');

      const response = await fetch('/cart/add.js?kaching_bundles=true', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Kaching-Cart-Ignore': '1'
        },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart add failed');

      els.atc.textContent = 'Redirecting...';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('kaching-cart:refresh'));
      window.location.href = checkoutUrl();
    } catch (error) {
      els.atc.textContent = 'Try again';
      setTimeout(() => {
        els.atc.disabled = false;
        els.atc.textContent = currentBundle().cta;
      }, 1800);
    }
  }

  kachingBridge()?.addEventListener('submit', (event) => {
    event.preventDefault();
  });

  els.tabs?.addEventListener('click', (event) => {
    const tab = event.target.closest('.sar-tab');
    if (tab) resetSelections(tab.dataset.bundle);
  });

  els.items?.addEventListener('click', (event) => {
    const editButton = event.target.closest('[data-item-edit]');
    if (!editButton) return;
    if (window.matchMedia('(max-width: 768px)').matches) {
      openModal(editButton.dataset.itemEdit);
    }
  });

  els.items?.addEventListener('change', (event) => {
    const select = event.target.closest('[data-control][data-item-id]');
    if (!select) return;
    updateSelection(select.dataset.itemId, select.dataset.control, select.value);
  });

  function openSizeGuide(type = 'hoodie') {
    if (!els.sizeGuide) return;
    const guideType = type === 'pants' ? 'pants' : 'hoodie';
    $$('[data-size-guide-panel]', els.sizeGuide).forEach((panel) => {
      panel.hidden = panel.dataset.sizeGuidePanel !== guideType;
    });
    els.sizeGuide.hidden = false;
    els.sizeGuide.setAttribute('aria-hidden', 'false');
  }

  root.addEventListener('click', (event) => {
    const sizeGuideOpen = event.target.closest('[data-sar-size-guide-open]');
    if (!sizeGuideOpen) return;
    event.preventDefault();
    openSizeGuide(sizeGuideOpen.dataset.guideType);
  });

  els.modalGroups?.addEventListener('click', (event) => {
    const choice = event.target.closest('.sar-choice');
    if (!choice) return;
    const group = choice.closest('[data-choice-key]');
    $$('.sar-choice', group).forEach((button) => button.classList.toggle('is-active', button === choice));
  });

  els.sizeGuide?.addEventListener('click', (event) => {
    if (event.target.closest('[data-sar-size-guide-close]')) {
      els.sizeGuide.hidden = true;
      els.sizeGuide.setAttribute('aria-hidden', 'true');
      return;
    }

    const unitButton = event.target.closest('[data-size-unit]');
    if (!unitButton) return;
    const unit = unitButton.dataset.sizeUnit;
    const panel = unitButton.closest('[data-size-guide-panel]') || els.sizeGuide;
    $$('[data-size-unit]', panel).forEach((button) => {
      const active = button === unitButton;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    $$('[data-size-table]', panel).forEach((table) => {
      table.hidden = table.dataset.sizeTable !== unit;
    });
  });

  $('[data-sar-modal-close]')?.addEventListener('click', () => closeModal(false));
  els.modal?.addEventListener('click', (event) => {
    if (event.target === els.modal) closeModal(false);
  });
  els.modalSave?.addEventListener('click', () => closeModal(true));
  els.atc?.addEventListener('click', addToCart);
  els.stickyScroll?.addEventListener('click', () => root.querySelector('#sensory-aromatherapy-offer')?.scrollIntoView({ behavior: 'smooth' }));

  $$('.sar-video-card__play').forEach((button) => {
    const video = button.closest('.sar-video-card')?.querySelector('video');
    if (!video) return;
    button.addEventListener('click', () => {
      if (video.paused) {
        $$('.sar-video-card__video').forEach((other) => { if (other !== video) other.pause(); });
        video.play();
        button.classList.add('is-playing');
        button.setAttribute('aria-label', 'Pause customer video');
      } else {
        video.pause();
        button.classList.remove('is-playing');
        button.setAttribute('aria-label', 'Play customer video');
      }
    });
    video.addEventListener('pause', () => {
      button.classList.remove('is-playing');
      button.setAttribute('aria-label', 'Play customer video');
    });
  });

  const therapistVideo = $('.sar-therapist__video');
  const therapistPlay = $('.sar-therapist__play');
  therapistPlay?.addEventListener('click', () => {
    if (!therapistVideo) return;
    if (therapistVideo.paused) {
      therapistVideo.play();
      therapistPlay.classList.add('is-playing');
      therapistPlay.setAttribute('aria-label', 'Pause therapist video');
    } else {
      therapistVideo.pause();
      therapistPlay.classList.remove('is-playing');
      therapistPlay.setAttribute('aria-label', 'Play therapist video');
    }
  });
  therapistVideo?.addEventListener('pause', () => {
    if (therapistPlay) {
      therapistPlay.classList.remove('is-playing');
      therapistPlay.setAttribute('aria-label', 'Play therapist video');
    }
  });

  function updateStickyVisibility() {
    const offer = root.querySelector('#sensory-aromatherapy-offer');
    const offerRect = offer?.getBoundingClientRect();
    const offerIsVisible = offerRect ? offerRect.top < window.innerHeight && offerRect.bottom > 0 : false;
    const show = window.scrollY > 600 && !offerIsVisible;
    els.sticky?.classList.toggle('is-visible', show);
    els.sticky?.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener('resize', updateStickyVisibility);

  resetSelections('set');
  updateStickyVisibility();
})();
